import { useEffect, useState } from "react";
import axios from "axios";
import VehicleCard from "@/components/VehicleCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CATEGORIES = [
  { id: "todos", label: "Todos" },
  { id: "suv", label: "SUV" },
  { id: "sedan", label: "Sedan" },
  { id: "hatchback", label: "Hatchback" },
  { id: "coupe", label: "Coupé" },
  { id: "carrinha", label: "Carrinha" },
  { id: "citadino", label: "Citadino" },
];

export function enquireVehicle(vehicle) {
  sessionStorage.setItem("lead_vehicle_id", vehicle.id);
  const el = document.querySelector("#contacto");
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
    window.dispatchEvent(new CustomEvent("lead:vehicle", { detail: vehicle }));
  }
}

export default function Stock() {
  const [vehicles, setVehicles] = useState([]);
  const [active, setActive] = useState("todos");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axios
      .get(`${API}/vehicles`, { params: active === "todos" ? {} : { category: active } })
      .then((res) => {
        if (!cancelled) setVehicles(res.data);
      })
      .catch(() => {
        if (!cancelled) setVehicles([]);
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [active]);

  return (
    <section id="stock" data-testid="stock-section" className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10">
          <div>
            <p className="text-xs font-semibold tracking-[0.35em] uppercase text-slate-500 mb-4">
              Viaturas Disponíveis
            </p>
            <h2
              data-testid="stock-heading"
              className="font-display text-3xl sm:text-4xl tracking-tight text-[#0072C6]"
            >
              Stock em Destaque
            </h2>
          </div>
          <p className="text-sm text-slate-500 max-w-sm">
            Seleção de viaturas disponíveis. Para o catálogo completo com filtros, <a href="/viaturas" className="text-[#0072C6] font-semibold underline">ver todos os automóveis</a>.
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-10" data-testid="stock-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              data-testid={`filter-${c.id}`}
              onClick={() => setActive(c.id)}
              className={`px-5 py-2.5 text-sm font-medium tracking-wide border transition-colors ${
                active === c.id
                  ? "bg-[#0072C6] text-white border-[#0072C6]"
                  : "bg-white text-slate-600 border-slate-200 hover:border-[#0072C6] hover:text-[#0072C6]"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="py-20 text-center text-slate-400 text-sm" data-testid="stock-loading">
            A carregar viaturas…
          </div>
        ) : vehicles.length === 0 ? (
          <div className="py-20 text-center text-slate-400 text-sm" data-testid="stock-empty">
            Sem viaturas nesta categoria de momento.
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="stock-grid">
            {vehicles.map((v) => (
              <VehicleCard key={v.id} vehicle={v} onEnquire={enquireVehicle} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
